import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  center: {
    display: "flex",
    justifyContent: "center",
    overflow: "auto",
  },
  container: {
    width: "100%",
    maxWidth: 1366,
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    padding: "5rem 5rem",
    alignItems: "flex-start",
    [theme.breakpoints.down("lg")]: {
      padding: "1rem 1rem 0rem 1rem",
    },
  },
  header: {
    fontWeight: "bold",
    fontSize: 36,
    color: "#ffffff",
  },
  subHeader: {
    fontWeight: 300,
    fontSize: 16,
    marginTop: "1rem",
    marginBottom: "2rem",
    maxWidth: 582,
  },
  headerContainer: {
    maxWidth: "483px",
    [theme.breakpoints.down("lg")]: {
      marginLeft: "0rem",
    },
  },
  contentContainer: {
    marginLeft: "2rem",
    maxWidth: "483px",
    [theme.breakpoints.down("lg")]: {
      marginLeft: "0rem",
    },
  },
}));

interface RegFormScreenProps {
  header?: string;
  subHeader?: any;
  hideBackground?: boolean;
  children?: any;
}

const opaqueStyle = {
  backgroundColor: "#fafafa",
  color: "#000000E6",
};

const defaultStyle = {
  backgroundColor: "unset",
  color: "#F3F3F3",
};

export const RegistrationFormScreen = (props: RegFormScreenProps) => {
  const { header = "", subHeader = "", hideBackground = false } = props;
  const classes = useStyles();

  return (
    <div className={classes.center}>
      <Stack
        className={classes.container}
        style={hideBackground ? opaqueStyle : defaultStyle}
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "center" }}>
        <div className={classes.headerContainer}>
          <Typography component="h1" variant="h5" className={classes.header}>
            {header}
          </Typography>
          <Typography component="main" variant="body1" className={classes.subHeader}>
            {subHeader}
          </Typography>
        </div>
        <div className={classes.contentContainer}>{props.children}</div>
      </Stack>
    </div>
  );
};
